import * as React from "react";

const BubbleEmptyRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" focusable="false" viewBox="0 -960 960 960">
            <path fill="none" d="M-2-2h24v24H-2z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M160-240q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v623q0 27-24.5 37.5T812-148l-92-92H160Zm0-80v-480 480Zm594 0 46 45v-525H160v480h594Z"
            />
        </svg>
    );
};

export default React.memo(BubbleEmptyRight);
